import './request-info.scss';
import {useIntl} from "react-intl";
import {Field, useFormikContext} from 'formik';
import { WLOCreditAPIService } from '../../../services';
import _ from 'lodash';
import {useLoginContext} from '../../../hooks/useLoginContext';
import {useRequestContext} from '../../../hooks/useRequestContext';
import {useTiposIdentificacion} from '../../../hooks/useTiposIdentificacion';
import toast from 'react-hot-toast';
import {useState, useEffect, useRef} from 'react';
import {CygnusPersona} from '../../../context/RequestContext';
import BarLoader from "react-spinners/BarLoader";

interface FormKnowYouMobileProps {
    errors?: any;
    values?: any;
}

export function FormKnowYouMobile(props: FormKnowYouMobileProps) {
    const {user} = useLoginContext();
    const {request, setRequest} = useRequestContext();
    const {setFieldValue, handleChange} = useFormikContext<any>();
    const [isLoadingInfo, setIsLoadingInfo] = useState(false);
    const { tiposIdentificacion, defaultTipoCodigo } = useTiposIdentificacion();
    const searchIdRef = useRef(0);
    const {errors, values} = props;
    const intl = useIntl();
    const isVendedor = user?.idProfile === '4';

    const clearIdentityData = (clearFecha = true) => {
        setFieldValue('Pws_Nombres', '');
        setFieldValue('Pws_Apellidos1', '');
        setFieldValue('Pws_Apellidos2', '');
        if (clearFecha) {
            setFieldValue('Pws_Fec_expe', '');
        }
        setRequest({
            ...request,
            personCygnus: undefined,
            personANI: undefined,
            personCode: undefined,
            direcciones: undefined,
            searchANI: false,
        });
        localStorage.removeItem('person');
        localStorage.removeItem('estadoCedula');
    };

    const isSearchCurrent = (searchId: number) => searchId === searchIdRef.current;

    const handleIdentificationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        clearIdentityData(true);
        handleChange(e);
    };

    const handleSearch = async (numDoc?: string, numTipoDoc?: string) => {
        const doc = numDoc ?? values.Pws_Identificacion;
        const tipoDoc = numTipoDoc ?? values.Pws_Tip_Identificacion;

        if (_.isEmpty(tipoDoc) && _.isEmpty(doc)) {
            return;
        }

        if (String(doc).length < 5) {
            toast.error('Debe indicar un Número de Identificación entre 5 y 10 caracteres', { duration: 5000 });
            return;
        }

        const searchId = ++searchIdRef.current;
        clearIdentityData(isVendedor);
        setIsLoadingInfo(true);

        try {
            const person = await WLOCreditAPIService.consultaSolicitudCygnus({
                Pws_Tip_Identificacion: tipoDoc!,
                Pws_Identificacion: doc!
            });

            if (!isSearchCurrent(searchId)) return;

            if (!_.isEmpty(person.payload)) {
                if (person.payload.result === "1") {
                    const pCygnus = person.payload.data.datos_persona.Datos_persona[0] as CygnusPersona;
                    setFieldValue('Pws_Apellidos1', pCygnus.Pws_Apellidos1);
                    setFieldValue('Pws_Apellidos2', pCygnus.Pws_Apellidos2);
                    setFieldValue('Pws_Nombres', pCygnus.Pws_Nombres);
                    setRequest({...request, personCygnus: pCygnus, searchANI: false, errorConsulta: false});
                    localStorage.setItem('person', JSON.stringify(person.payload.data.datos_persona.Datos_persona[0]));
                    setIsLoadingInfo(false);
                } else {
                    // ANI deshabilitado: cliente Panamá — continuar con captura manual
                    // try {
                    //     const personANI = await WLOCreditAPIService.consultaSolicitudANI({
                    //         Pws_Tip_Identificacion: tipoDoc!,
                    //         Pws_Identificacion: doc!
                    //     });
                    //
                    //     if (!isSearchCurrent(searchId)) return;
                    //
                    //     const pANI = personANI as ANIPersona;
                    //     setFieldValue('Pws_Apellidos1', pANI.primerApellido);
                    //     setFieldValue('Pws_Apellidos2', pANI.segundoApellido);
                    //     setFieldValue('Pws_Nombres', [pANI.primerNombre, pANI.segundoNombre].filter(Boolean).join(' '));
                    //     setFieldValue('Pws_Fec_expe', WLOCreditAPIService.fechaAniToFormIso(pANI.fechaExpedicion));
                    //     setRequest({...request, personANI: pANI, searchANI: true, errorConsulta: false});
                    //     localStorage.setItem('person', JSON.stringify(personANI));
                    //     setIsLoadingInfo(false);
                    // } catch (e) {
                    //     if (!isSearchCurrent(searchId)) return;
                    //     clearIdentityData(isVendedor);
                    //     if (e instanceof AniConsultaError && e.allowManual) {
                    //         setRequest({...request, searchANI: true, errorConsulta: false});
                    //     } else {
                    //         setRequest({...request, errorConsulta: true});
                    //     }
                    //     setIsLoadingInfo(false);
                    // }
                    if (!isSearchCurrent(searchId)) return;
                    clearIdentityData(isVendedor);
                    setRequest({...request, searchANI: true, errorConsulta: false});
                    setIsLoadingInfo(false);
                }
            } else {
                clearIdentityData(isVendedor);
                toast.error('En estos momentos no podemos atender su solicitud', { duration: 5000 });
                setIsLoadingInfo(false);
            }
        } catch (e) {
            if (!isSearchCurrent(searchId)) return;
            clearIdentityData(isVendedor);
            const error = e as any;
            setRequest({...request, errorConsulta: true});
            if (!_.isEmpty(error?.response?.data)) {
                toast.error(String(error.response.data), { duration: 5000 });
            } else {
                toast.error('En estos momentos no podemos atender su solicitud', { duration: 5000 });
            }
            setIsLoadingInfo(false);
        }
    };

    useEffect(() => {
        const datosPersonaString = localStorage.getItem("personaValidada");
        if (!isVendedor && datosPersonaString) {
            const datosPersona = JSON.parse(datosPersonaString);
            const numDoc = datosPersona.numIdenVal;
            const numTipoDoc = datosPersona.tipIdenVal;
            if (numDoc) setFieldValue('Pws_Identificacion', numDoc);
            if (numTipoDoc) setFieldValue('Pws_Tip_Identificacion', numTipoDoc);
            if (numDoc && numTipoDoc) handleSearch(numDoc, numTipoDoc);
            return;
        }

        if (tiposIdentificacion.length > 0 && !values.Pws_Tip_Identificacion) {
            setFieldValue('Pws_Tip_Identificacion', defaultTipoCodigo);
        }

        if (values.Pws_Identificacion && values.Pws_Tip_Identificacion) {
            handleSearch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVendedor, tiposIdentificacion, defaultTipoCodigo]);

    return (
        <div className={'row'}>
            <div className="col-2"/>
            <div className="col-8">
                <div
                    className={"title-medium-red-mobile"}>{intl.formatMessage({id: "form_credit_information_title"})}</div>
            </div>
            <div className="col-2"/>
            <div
                className={"subtitle-medium-mobile"}>{intl.formatMessage({id: "form_credit_information_subtitle"})}</div>
                <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field as="select"
                        id={"Pws_Tip_Identificacion"}
                        name={"Pws_Tip_Identificacion"}
                        className={'form-know-you-item-input-mobile'}
                        disabled={!isVendedor}>
                        <option value="">{errors && errors.Pws_Tip_Identificacion ? errors.Pws_Tip_Identificacion : intl.formatMessage({id: "placeholder_identification_type"})}</option>
                        {tiposIdentificacion.map((item, key: number) => (
                            <option key={key} value={item.s_codigo}>{item.s_descripcion}</option>
                        ))}
                    </Field>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Identificacion"}
                        name={"Pws_Identificacion"}
                        className={'form-know-you-item-input-mobile'}
                        disabled={!isVendedor}
                        onChange={isVendedor ? handleIdentificationChange : undefined}
                        onBlur={() => {
                            if (isVendedor && values.Pws_Identificacion?.trim() && values.Pws_Tip_Identificacion) {
                                handleSearch();
                            }
                        }}
                        placeholder={errors && errors.Pws_Identificacion ? errors.Pws_Identificacion : intl.formatMessage({id: "placeholder_document_number"})}/>
                    <BarLoader height={4} width={300} color={"#d72222"} loading={isLoadingInfo}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Nombres"}
                        name={"Pws_Nombres"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={"Nombres"}/>
                </div>
            </div>
            
            <div className={'flex-container-form-know-you'}>
                 <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Apellidos1"}
                        name={"Pws_Apellidos1"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={"Primer apellido"}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
            <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Apellidos2"}
                        name={"Pws_Apellidos2"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={"Segundo apellido"}/>
                </div>
            </div>
            
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Telefono1"}
                        name={"Pws_Telefono1"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={errors && errors.Pws_Telefono1 ? errors.Pws_Telefono1 : intl.formatMessage({id: "placeholder_phone_1"})}
                    />
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Telefono2"}
                        name={"Pws_Telefono2"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={errors && errors.Pws_Telefono2 ? errors.Pws_Telefono2 : intl.formatMessage({id: "placeholder_phone_2"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"Pws_Correo"}
                        name={"Pws_Correo"}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={errors && errors.Pws_Correo ? errors.Pws_Correo : intl.formatMessage({id: "placeholder_mail"})}/>
                </div>
            </div>
            <div className={'flex-container-form-know-you'}>
                <div className={"flex-container-form-know-you-item-center flex-grow-12"}>
                    <Field id={"mail_confirmation"}
                        autoComplete="off"
                        name={"mail_confirmation"}
                        onPaste={(e:any)=>{
                        e.preventDefault()
                        return false;
                        }}
                        className={'form-know-you-item-input-mobile'}
                        placeholder={intl.formatMessage({id: "placeholder_mail_confirmation"})}/>
                </div>
            </div>
        </div>

    )
}
